import { en, type Messages } from './en';
import type { LoadedLocale } from './I18nProvider';
import { preferredLocale, type Locale } from './locales';

type Loader = () => Promise<{ readonly messages: Messages }>;

// English is built in; every other language loads only when it's chosen.
const LOADERS: Readonly<Record<Exclude<Locale, 'en'>, Loader>> = {
  es: () => import('./locales/es'),
  fr: () => import('./locales/fr'),
  de: () => import('./locales/de'),
  it: () => import('./locales/it'),
  pt: () => import('./locales/pt'),
  nl: () => import('./locales/nl'),
  pl: () => import('./locales/pl'),
  uk: () => import('./locales/uk'),
  cs: () => import('./locales/cs'),
  sv: () => import('./locales/sv'),
  da: () => import('./locales/da'),
  no: () => import('./locales/no'),
  fi: () => import('./locales/fi'),
  ro: () => import('./locales/ro'),
  el: () => import('./locales/el'),
  tr: () => import('./locales/tr'),
  ar: () => import('./locales/ar'),
  he: () => import('./locales/he'),
  hi: () => import('./locales/hi'),
  id: () => import('./locales/id'),
  vi: () => import('./locales/vi'),
  th: () => import('./locales/th'),
  ja: () => import('./locales/ja'),
  ko: () => import('./locales/ko'),
  zh: () => import('./locales/zh'),
};

/** The interface's words in `locale`. */
export async function loadMessages(locale: Locale): Promise<Messages> {
  if (locale === 'en') return en;
  return (await LOADERS[locale]()).messages;
}

/** The person's language, loaded; English if it can't load. */
export async function loadPreferredLocale(): Promise<LoadedLocale> {
  const locale = preferredLocale();
  try {
    return { locale, messages: await loadMessages(locale) };
  } catch {
    return { locale: 'en', messages: en };
  }
}
